module.exports = __webpack_public_path__ + "static/media/5.question.ed03e25a.mp4";